import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { ZippyEventType, parseZippyName, subject } from '@df/legacy/ui/zippy/zippy.abstract';
import { ZippyService } from '@df/legacy/ui/zippy/zippy.service';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { ImageModule } from '@df/module-image/image.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { IfNotTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-not-trade-store.directive';
import { Expandable2Component } from 'projects/app-default/src/app/ui/display/expandable/expandable2.component';
import { ScrollNavTargetDirective } from 'projects/app-default/src/app/ui/scroll-nav/scroll-nav-target.directive';
import SwiperCore, { Navigation, Scrollbar } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { LocalProduct } from '../../../model/product/product.decorator';
import { ReadMoreComponent } from '../../display/read-more/read-more.component';
import { ProductReviewsSummaryComponent } from '../product-reviews-summary/product-reviews-summary.component';
import { NProductViewLayout } from '../view-layout/product-view-layout.interface';
SwiperCore.use([Scrollbar, Navigation]);
@Component({
    selector: 'product-view-details',
    templateUrl: './product-view-details.html',
    standalone: true,
    imports: [
        DfUiModule,
        Expandable2Component,
        GridModule,
        ICmsClientModule,
        IfNotTradeStoreDirective,
        ImageModule,
        DfModuleImageModule,
        ProductReviewsSummaryComponent,
        ReadMoreComponent,
        ScrollNavTargetDirective,
        SwiperModule,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./product-view-details.component.scss']
})
export class ProductViewDetailsComponent extends UiComponent implements OnChanges {
    @Input({ required: true })
    product!: LocalProduct<IProductDataV3>;
    @Input({ required: true })
    parent!: Product<IProductDataV3>;
    @Input({ required: true })
    content!: NProductViewLayout.IBlockDataContent;
    readonly detailsZippyId = ['pdp_accordion', 'product_details'];
    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes['product'] || changes['parent']) {
            subject.next({
                id: parseZippyName(this.detailsZippyId),
                type: ZippyEventType.open
            });
        }
    }

    get showReviews(): boolean {
        return !!this.parent?.data?.reviews?.count || false;
    }

    protected zippyService = inject(ZippyService);
}
